import { Navigate } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { PerformanceGoalsTabsDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { type ValidSection, getValidSection } from 'modules/performance_goals/pages/TeamDashboard'

const RedirectToRoutePage = () => {
  const { navigation } = useNavigation()
  const { employee } = useCurrentSession()
  const { loading, data } = useQuery(PerformanceGoalsTabsDocument, {
    variables: {
      currentEmployeeId: employee?.id,
    },
  })
  const canSeeOtherEmployees = Boolean(data?.goals?.employeesConnection?.totalCount)

  const paths: Record<ValidSection, string> = {
    people: navigation.performanceGoals.employees.fullPath(),
    groups: navigation.performanceGoals.groups.fullPath(),
  }

  if (loading)
    return (
      <Box width="full" alignItems="center" height="full" justifyContent="center">
        <Spinner />
      </Box>
    )

  const section = getValidSection({ canSeeOtherEmployees })

  return <Navigate replace to={paths[section]} />
}

export default RedirectToRoutePage
